import { render, staticRenderFns } from "./foodManage.vue?vue&type=template&id=7f46a879&scoped=true&"
import script from "./foodManage.vue?vue&type=script&lang=js&"
export * from "./foodManage.vue?vue&type=script&lang=js&"
import style0 from "./foodManage.vue?vue&type=style&index=0&id=7f46a879&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f46a879",
  null
  
)

export default component.exports